var React = require('react');

function DotPattern (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"0.145508","width":"1","height":"0.993388","fill":"#FF6600","key":0}),React.createElement("rect",{"y":"11.0728","width":"1","height":"0.993388","fill":"#FF6600","key":1}),React.createElement("rect",{"x":"11","y":"0.145508","width":"1","height":"0.993388","fill":"#FF6600","key":2}),React.createElement("rect",{"x":"11","y":"11.0728","width":"1","height":"0.993388","fill":"#FF6600","key":3})]);
}

DotPattern.defaultProps = {"width":"12","height":"12","viewBox":"0 0 10 10","fill":"none"};

module.exports = DotPattern;

DotPattern.default = DotPattern;
